
import { Company } from './Company';
import { RelationshipType, RelationshipDataItem } from './partner';
import { PartnerUser  } from './PartnerUser';
import { Privilege, PrivilegeGroup } from './UserRelationship';

export class PartnerRelationship {
    RelationshipId?: number;
    IsActive: boolean;
    RelationshipType: RelationshipType;
    ParentCompany?: Company;
    ChildCompany?: Company;
    ChildCompanyAlias?: string;
    UserCount?: number;
    PartnerUser: PartnerUser[];
    MasterDataKeys: RelationshipDataItem[];
    UniqueKey?: string;
    Privileges?: Privilege[];
    PrivilegeGroups?: PrivilegeGroup[];
}

